var map = {
	"./de-DE": [
		97859,
		174
	],
	"./de-DE.json": [
		97859,
		174
	],
	"./en-PI": [
		74710,
		124
	],
	"./en-PI.json": [
		74710,
		124
	],
	"./en-US": [
		45821,
		758
	],
	"./en-US.json": [
		45821,
		758
	],
	"./es-ES": [
		30701,
		958
	],
	"./es-ES.json": [
		30701,
		958
	],
	"./fr-FR": [
		68586,
		462
	],
	"./fr-FR.json": [
		68586,
		462
	],
	"./sv-SE": [
		24599,
		674
	],
	"./sv-SE.json": [
		24599,
		674
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 98908;
module.exports = webpackAsyncContext;